import { useParams } from 'react-router-dom';

/**
 * Hook that provides a function to create localized paths
 * @returns Function that takes a path and returns it with the current language prefix
 */
export const useLocalizedPath = () => {
  const { lang } = useParams();
  
  return (path: string) => {
    const language = lang || 'en';
    // Ensure path starts with /
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${language}${cleanPath}`;
  };
};

/**
 * Utility function to create localized path with specific language
 * @param lang - Language code (en, hi, ta)
 * @param path - Path to localize
 * @returns Localized path with language prefix
 */
export const createLocalizedPath = (lang: string, path: string) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `/${lang}${cleanPath}`;
};

/**
 * Extract the path without language prefix
 * @param pathname - Full pathname from location
 * @returns Path without language prefix
 */
export const getPathWithoutLang = (pathname: string) => {
  const stripped = pathname.replace(/^\/(en|cn|zh|de|es|pl|hi|ta|te|ne|he|fr|ja|pt|id|ru|nl)/, '');
  const normalized = stripped ? (stripped.startsWith('/') ? stripped : `/${stripped}`) : '/';
  return normalized;
};